module.exports = __webpack_public_path__ + "img/sprinkle-6.3fb2f6b8.webp";